"use client";

import { SessionInfo } from "@b2bportal/auth-api";
import { PropsWithChildren } from "react";

interface IProtectedRouteProps extends PropsWithChildren {
  sessionInfo?: SessionInfo;
}

const ProtectedRoute = ({ children, sessionInfo }: IProtectedRouteProps) => {
  if (sessionInfo && !sessionInfo.userInfo) {
    return "Unauthorized";
  }
  return children;
};

export default ProtectedRoute;
